import { mapMutations } from 'vuex';

export default {
  watch: {
    '$route.query.sard'(newValue) {
      if (newValue?.length) {
        this.$store.commit('general/setAuthRedirectParams', newValue);
      }
    }
  },
  methods: {
    ...mapMutations({
      setWindowSize: 'general/setWindowSize'
    })
  },
  beforeCreate() {
    const { isBusy, accessToken } = this.$store.state.auth;
    if (!isBusy && !accessToken) {
      this.$store.commit('general/setSendAuthorizationHeader', false);
    }
    if (this.$route.query.sard && this.$route.query.sard.length) {
      this.$store.commit('general/setAuthRedirectParams', this.$route.query.sard);
    }
  },
  beforeMount() {
    /* eslint-disable id-length */
    this.setWindowSize({ x: window.innerWidth, y: window.innerHeight });
    window.addEventListener(
      'resize',
      () => {
        this.setWindowSize({ x: window.innerWidth, y: window.innerHeight });
      },
      true
    );
    /* eslint-enable */
  }
};
